import { render, staticRenderFns } from "./NegociacaoAlterarResposta.vue?vue&type=template&id=4e4b0f4d&scoped=true"
import script from "./NegociacaoAlterarResposta.vue?vue&type=script&lang=js"
export * from "./NegociacaoAlterarResposta.vue?vue&type=script&lang=js"
import style0 from "./NegociacaoAlterarResposta.vue?vue&type=style&index=0&id=4e4b0f4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4b0f4d",
  null
  
)

export default component.exports